import script from "./ArticleRelate.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleRelate.vue?vue&type=script&setup=true&lang=js"

import "./ArticleRelate.vue?vue&type=style&index=0&id=407c530b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-407c530b"]])

export default __exports__